import React from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ObjetivoV2Vendedores({
  isEdicao,
  vendedores,
  setVendedores,
  catalogoVendedores,
  equipas,
}) {
  const obterRefVendedor = (item) => String(item?.refvendedor || item?.ref || "").trim();

  const obterNomeVendedor = (item) => String(item?.vendedor || item?.nome || "").trim();

  const refsEquipa = new Set(
    (Array.isArray(equipas) ? equipas : [])
      .flatMap((equipa) => (Array.isArray(equipa?.vendedores) ? equipa.vendedores : []))
      .map((vendedor) => obterRefVendedor(vendedor))
      .filter(Boolean)
  );

  const refsIndividuais = new Set(
    (Array.isArray(vendedores) ? vendedores : [])
      .map((vendedor) => obterRefVendedor(vendedor))
      .filter(Boolean)
  );

  const catalogoDisponivel = (Array.isArray(catalogoVendedores) ? catalogoVendedores : []).filter(
    (vendedor) => !refsEquipa.has(obterRefVendedor(vendedor))
  );

  const adicionarVendedor = () => {
    setVendedores((prev) => [
      ...prev,
      {
        id: null,
        refvendedor: "",
        vendedor: "",
        valor: "",
      },
    ]);
  };

  const alterarVendedor = (index, campos) => {
    setVendedores((prev) =>
      prev.map((vendedor, i) =>
        i === index
          ? {
              ...vendedor,
              ...campos,
            }
          : vendedor
      )
    );
  };

  const removerVendedor = (index) => {
    setVendedores((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <MDBox mt={2}>
      <Card>
        <MDBox p={2}>
          <MDBox
            display="flex"
            alignItems={{
              xs: "stretch",
              sm: "center",
            }}
            justifyContent="space-between"
            flexDirection={{
              xs: "column",
              sm: "row",
            }}
            gap={1}
            mb={2}
          >
            <MDBox>
              <MDTypography variant="h6">Objetivos individuais</MDTypography>

              <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                Vendedores com objetivo individual.
              </MDTypography>
            </MDBox>

            <MDButton
              color="info"
              startIcon={<AddIcon />}
              onClick={adicionarVendedor}
              disabled={!isEdicao}
              sx={{
                width: {
                  xs: "100%",
                  sm: "auto",
                },
              }}
            >
              Adicionar vendedor
            </MDButton>
          </MDBox>

          {vendedores.length === 0 ? (
            <MDBox minHeight={90} display="flex" alignItems="center" justifyContent="center">
              <MDTypography variant="button" color="text" textAlign="center">
                Não existem objetivos individuais configurados.
              </MDTypography>
            </MDBox>
          ) : (
            <MDBox display="flex" flexDirection="column" gap={1.5}>
              {vendedores.map((vendedor, index) => {
                const refAtual = obterRefVendedor(vendedor);

                const opcoes = catalogoDisponivel.filter((item) => {
                  const ref = obterRefVendedor(item);

                  return ref === refAtual || !refsIndividuais.has(ref);
                });

                const valorSelecionado =
                  catalogoVendedores.find((item) => obterRefVendedor(item) === refAtual) ||
                  (refAtual ? vendedor : null);

                return (
                  <MDBox
                    key={`vendedor-${vendedor?.id || "novo"}-${index}`}
                    display="grid"
                    gridTemplateColumns={{
                      xs: "1fr",
                      md: "minmax(0, 1fr) 180px auto",
                    }}
                    gap={2}
                    alignItems="center"
                  >
                    <Autocomplete
                      size="small"
                      options={opcoes}
                      value={valorSelecionado}
                      getOptionLabel={(option) => {
                        const ref = obterRefVendedor(option);
                        const nome = obterNomeVendedor(option);

                        return nome ? `${ref} - ${nome}` : ref;
                      }}
                      isOptionEqualToValue={(option, value) =>
                        obterRefVendedor(option) === obterRefVendedor(value)
                      }
                      onChange={(_, value) =>
                        alterarVendedor(index, {
                          refvendedor: obterRefVendedor(value),
                          vendedor: obterNomeVendedor(value),
                        })
                      }
                      disabled={!isEdicao}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Selecionar vendedor..." />
                      )}
                    />

                    <MDInput
                      type="number"
                      fullWidth
                      value={vendedor?.valor ?? ""}
                      onChange={(e) => {
                        const valor = e.target.value;

                        alterarVendedor(index, {
                          valor: valor === "" ? "" : Math.max(0, parseInt(valor, 10) || 0),
                        });
                      }}
                      inputProps={{
                        min: 0,
                        step: 1,
                      }}
                    />

                    <MDBox
                      display="flex"
                      justifyContent={{
                        xs: "flex-end",
                        md: "center",
                      }}
                    >
                      <Tooltip title="Remover objetivo individual">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => removerVendedor(index)}
                          disabled={!isEdicao}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                );
              })}
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
